<template>
  <v-snackbar
    v-model="$store.toastService.active"
    :top="true"
    :right="true"
    :color="$store.toastService.color"
  >
    <v-icon class="mr-2" v-if="$store.toastService.color=='warning'">mdi-alert-box</v-icon>
    <v-icon class="mr-2" v-if="$store.toastService.color=='info'">mdi-information</v-icon>
    <v-icon class="mr-2" v-if="$store.toastService.color=='error'">mdi-alert-box</v-icon>
    <v-icon class="mr-2" v-if="$store.toastService.color=='success'">mdi-check</v-icon>
    {{ $store.toastService.message }}
    <template v-slot:action="{ attrs }">
      <v-btn icon v-bind="attrs" @click="$store.toastService.active = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {};
</script>

<style>
</style>